<template>
  <div>
    <AppChip
      v-if="badge"
      v-bind="$attrs"
      color="horseSlot"
      text-color="white--text"
    >
      <slot>{{ $t("horses:common.horseSlot.badge", "Horse Slot") }}</slot>
    </AppChip>
    <template v-else
      ><slot>{{
        $t("horses:common.horseSlot.text", "Horse Slot")
      }}</slot></template
    >
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";

import AppChip from "@elements/AppChip.vue";

export default defineComponent({
  name: "AppHorseSlot",
  components: { AppChip },
  props: {
    badge: {
      type: Boolean,
      default: false
    }
  },
  fragments: {
    registrationHorseFields: gql`
      fragment _ on RegistrationHorse {
        isHorseSlot
      }
    `,
    horseFields: gql`
      fragment _ on Horse {
        isHorseSlot
      }
    `
  }
});
</script>
